import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Col, Form, Input, notification, Row } from 'antd'

import { handleBackendError } from '../../../../utils'

import { createCorporateUser } from '../../api'

export const NewCorporateUserForm = ({ resetSelectedMenu, selectedStore }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()

  const handleSubmit = () => {
    const isFormUpdated = form.isFieldsTouched()

    if (isFormUpdated) {
      form.validateFields().then(() => {
        setIsLoading(true)

        const requiredFieldsValue = form.getFieldsValue(['name', 'email', 'zip_code'])
        const fieldsValue = {
          ...requiredFieldsValue,
          store_id: selectedStore.id,
        }

        createCorporateUser(fieldsValue)
          .then(() => {
            setIsLoading(false)

            notification.success({
              description: 'Corporate user created successfully',
              duration: 5,
              title: 'Success',
            })

            resetSelectedMenu()
          })
          .catch((error) => {
            setIsLoading(false)

            notification.error({
              description: handleBackendError(error, 'Creating corporate user failed!'),
              title: 'Error',
            })
          })
      })
    }
  }

  return (
    <Row style={{ marginTop: '20px' }}>
      <Col span={24}>
        <Form data-test="new-corporate-user-form" form={form} layout="vertical">
          <Form.Item label="Name" name="name" rules={[{ message: 'Please provide a name!', required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                message: 'Please provide an email!',
                required: true,
              },
              {
                message: 'The input is not valid email!',
                type: 'email',
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Zip Code"
            name="zip_code"
            rules={[{ message: 'Please provide zip_code code!', required: true }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Col>

      <Col offset={9} span={6}>
        <Button block disabled={isLoading} htmlType="submit" onClick={handleSubmit} type="primary">
          Submit
        </Button>
      </Col>
    </Row>
  )
}

NewCorporateUserForm.propTypes = {
  resetSelectedMenu: PropTypes.func,
  selectedStore: PropTypes.object,
}

export default NewCorporateUserForm
